<template>
	<div class="cb-cart cb-cart--multiple" v-if="recommendedAddons && recommendedAddons.length > 0">
		<div class="cb-section cb-section-addon">
		<div class="cb-section__title cb-section__title--st"><span>{{ct('cart.recommended_addon_title')}}</span><span class="cb-section__trailing"></span></div>
			<cb-slide-n-fade :is-list="true" :timeOut="true" :reCalculateMargin = "true">
				<div class="cb-item cb-transition__tab" v-for="(addon,index) in recommendedAddons" :key='index'>
					<div class="cb-item__group">
						<div class="cb-item__sub-group">
							<div class="cb-item__sub-group--left">
								<div class="cb-item__name">{{addonDisplayName(addon)}}</div>
								<div class="cb-item__price cb-item__price--sm">{{ getPrice(addon)}}</div>
							</div>
							<div class="cb-item__sub-group--right">
								<button-field :custom-class="'cb-button__border'" :style="themeColor" @next="addAddon($event, addon)">
									&plus; {{cmt('add')}}
								</button-field>
							</div>
						</div>
					</div>
				</div>
			</cb-slide-n-fade>
		</div>
	</div>
</template>
<script type="text/javascript">
import {
  mapGetters
} from "vuex"
import CartMixin from "@/mixins/cart-mixin"
import RecommendedAddonsMixin from "@/mixins/recommended-addons-mixin"
import Button from "@/components/collections/form/ButtonComponent"
import PriceHelper from "@/utils/item-pricing-helper"
import SubItemsModel from "@/utils/items-model";
import MultiDecimalHelper from "@/utils/multi-decimal"
import currencyFilter, { mdCurrencyFilter } from "@/filters/currency";

export default {
	components: {
			'button-field': Button,
	},
	mounted() {
		if(this.is_items_model) {
			this.$store.dispatch('fetch_recommended_addons', this.cart_plan.id);
		}
	},
  mixins: [CartMixin, RecommendedAddonsMixin],
  computed: {
    ...mapGetters([
      'recommended_addons',
	  'recommended_addons_v2',
      'currency_code',
      'cart_plan',
      'is_items_model'
    ]),
	recommendedAddonsV1() {
      if(this.is_items_model) {
        const plan = this.cart_plan;
        const attachedItems = this.$store.getters.recommended_addons
        const recommendedItemPrices = attachedItems.map(attachedItem => {
          const item = attachedItem.item;
          const itemPrices = attachedItem.item_prices.map(({item_price}) => item_price)
          const selectedItemPrice = SubItemsModel.getSuitableAddonItemPrice(plan, item, itemPrices)
          return {...selectedItemPrice, item};
        })
        const addonDetailsList = recommendedItemPrices.map(itemPrice => SubItemsModel.convertItemPriceToAddon(itemPrice, itemPrice.item))
        const addons = addonDetailsList.map(details => {
          const addon = {
            ...details,
            details: Object.assign({}, details),
          }
          const itemPrice = recommendedItemPrices.find(itemPrice => itemPrice.id == addon.id)
          const item = attachedItems.find(attachedItem => attachedItem.item.id == itemPrice.item_id)
          const {quantity, quantity_in_decimal} = this.getItemQuantityV1(item, itemPrice);
          if(quantity_in_decimal) addon.quantity_in_decimal = quantity_in_decimal;
          else if(quantity) addon.quantity = quantity;
          return addon;
        })
        return addons
      } else {
        return this.$store.getters.recommended_addons;
      }
    },
    recommendedAddonsV2() {
      if(this.is_items_model) {
		let recommendedItemPrices = this.$store.getters.recommended_addons_v2;
        const recommendedAddonsDetails = recommendedItemPrices?.map(itemPrice => SubItemsModel.convertItemPriceToAddon(itemPrice, itemPrice.item))
		const recommendedAddons = recommendedAddonsDetails?.map(details => {
          const addon = {
            ...details,
            details: Object.assign({}, details),
          }

          const itemPrice = recommendedItemPrices?.find(itemPrice => itemPrice.id == addon.id);
          const {quantity, quantity_in_decimal} = this.getItemQuantityV2(itemPrice);
          if(quantity_in_decimal) addon.quantity_in_decimal = quantity_in_decimal;
          else if(quantity) addon.quantity = quantity;
          return addon;
        })
        return recommendedAddons;
      } else {
        return this.$store.getters.recommended_addons;
      }
    }
  },
  methods: {
    addonDisplayName(addon) {
      if(this.is_items_model) return addon.invoice_name || addon.name;
      return addon.details.invoice_name || addon.details.name;
    },
	getRecommendedQuantityV1(addon) {
      const attachedItems = this.$store.getters.recommended_addons;
	    const itemId = addon.item_id
      const selectedAttachedItem = attachedItems.find(item => item.item_id == itemId);
      return {
        quantity: selectedAttachedItem.quantity,
        quantity_in_decimal: selectedAttachedItem.quantity_in_decimal,
      }
    },
	getItemQuantityV1(item, itemPrice) {
	    if(itemPrice.pricing_model == 'flat_fee') return {};
      let { quantity, quantity_in_decimal } = this.getRecommendedQuantityV1(itemPrice);
      // Set default if there's no recommended quantity
      if(itemPrice.pricing_model == 'per_unit' && !quantity) {
        quantity = 1;
	    }
      return { quantity, quantity_in_decimal };
    },
	getRecommendedQuantityV2(itemPrice) {
      return {
        quantity: itemPrice.recommended_quantity,
        quantity_in_decimal: itemPrice.recommended_quantity_in_decimal,
      }
    },
    getItemQuantityV2(itemPrice) {
	  if(itemPrice.pricing_model == 'flat_fee') return {};
      let { quantity, quantity_in_decimal } = this.getRecommendedQuantityV2(itemPrice);
      // Set default if there's no recommended quantity
      if(itemPrice.pricing_model == 'per_unit' && !quantity) {
        quantity = 1;
	  }

      return { quantity, quantity_in_decimal };
    },
    addAddon(event, addon) {
      this.$store.dispatch('add_recommended_addon', addon)
	},
	getPrice(addon) {
	  if(MultiDecimalHelper.isMultiDecimal(addon)) {
		  return mdCurrencyFilter(addon.amount_in_decimal, this.currency_code);
	  }
	  if(!this.is_items_model) {
		return currencyFilter(PriceHelper.getItemTotalPrice(addon.details, addon.quantity), this.currency_code);
	  }
      return currencyFilter(PriceHelper.getItemTotalPrice(addon, addon.quantity), this.currency_code);
	}
  },
}
</script>

<style lang="stylus">
.cb-button__border{
	box-shadow: none;
	background-color: transparent !important;
	border: 1px solid;
	text-transform: uppercase;
	border-radius: 4px;
	font-size: 12px;
	padding: 0 10px;
	font-weight: 500;
	height: 24px;
	line-height: 22px;
	&:hover{
			box-shadow: none;
	}
	.cb-button__text{
		color: inherit;
	}
}
</style>
<style lang="stylus" scoped>
.cb-section-addon{
	margin-top: 32px;
}
.cb-section{
	&__{
		&title{
			position: relative;
			display: flex;
			align-items: center;
			&:before{
				content: "\e02d";
				background-repeat: no-repeat;
    			font: normal normal normal 14px/1 hp;
				color: #1565c0;
				position: absolute;
				left: -18px;
			}
		}
		&trailing{
			position: relative;
			flex: 1;
			margin-left: 8px;
			&:after{
				height: 1px;
				background: #d7dbe9;
				position: absolute;
				top: 50%;
				transform: translateY(-50%);
				left: 0;
				right: 0;
				content: "";
			}

		}
	}

}
.cb-item{
	&:before {
		content: none;
	}
	&__{
		&price{
        color: #6d7278;
      }
	}

}
</style>
